import React, { useState } from 'react';
import { connect } from 'react-redux';

import { text2Html } from '../../tools/textTools.js';


import { Card, PartialText, Modal, TopicsSelect } from '../';

import {
  saveTemplateCatRelevance,
  saveTemplateCatOrder,
  saveTemplateTopicRelevance,
  saveTemplateTopicOrder,
  addTemplateTopic,
  removeTemplateTopic,
  removeTemplateCategory,
  setTemplateEditing
} from '../../actions';

import ModalTopic from './ModalTopic';

import './categorycard.css';



const CategoryCard = ({
  category,
  index,
  saveCatRelevance,
  saveTopicRelevance,
  removeCategory,
  removeTopic,
  addTopic,
  errorIds // ids of category/topic with error
}) => {

  /*
    category/topic structure from ~/models/template.js
  */
  const topicsHeader = [
    ['Topic','category-card-topic-name-line'],
    ['Information','category-card-topic-info-line-header'],
    ['Relevance','category-card-topic-relevance-line']
  ]


  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAddTopic, setIsOpenAddTopic] = useState(false);
  const [modalInfo, setModalInfo] = useState({topic:'',descr:''});

  const topicsTHs = topicsHeader.map((elem, index) => <p className={elem[1]} key={'topicsTHS_' + index}>{elem[0]}</p>);
  const {relevance, topics, order } = category;
  const _idCat = category._id;

  const name=category.category;

  // console.log('current category: '+name,category);

  let categoryHasError = errorIds.includes(_idCat);


  const onMore = ({ topic, descr }) => {
    return () => {
      setModalInfo({topic,descr});
      setIsOpen(true);
    }
  }

  const onCloseMore = ()=>{
    setIsOpen(false);
  }

  const onOpenCloseAddTopic=(state)=>{
    return ()=>setIsOpenAddTopic(state);
  }

  const onChangeTopicRelevance=(index1)=>{
    return ({target})=>{
      saveTopicRelevance(target.value, index, index1);
    }
  }


  const onAddTopic=({_id,topic,descr})=>{
    // console.log('onAddTopic',{topic,descr});
    addTopic({_id,topic,descr},index);
    onOpenCloseAddTopic(false)();
  }

  const onRemoveTopic=(topicIndex)=>{
    return ()=>{
      removeTopic(index,topicIndex)
    }
  }

  // topics rows
  const topicsRows = topics.map((topicElem, indexTopic) => {
    const {_id, relevance, topic } = topicElem;
    let { descr } = topicElem;
    descr=text2Html(descr);

    let hasError = errorIds.find(elem=>(elem[0]===_idCat && elem[1]===_id)) ? ' topic-error' : '';
    let nameHtml=<p className="category-card-topic-name-line">{topic}</p>;

    // empty
    if(!topic) {
      let select=false;
      if(index === 0) {
        select=<TopicsSelect onChange={()=>false} isOpen={true} />
      }
      nameHtml=(
        <div className="new-topic category-card-topic-name-line">
          <p>Click to add topic {select}</p>
        </div>
      );
    }

    const removeTopicBtn=<i onClick={onRemoveTopic(indexTopic)} className="icon-cancel-circled btn-remove-topic"></i>

    return (
      <div className={"topic-row"+hasError} key={'cat-topic-' + indexTopic}>
        {nameHtml}
        <p className="category-card-topic-info-line textfield1">
          <PartialText dangerousHtml={true} onMore={onMore({topic: topic, descr})} text={descr} />
        </p>
        <p className="category-card-topic-relevance-line">
          <input className="textfield1 textfield1-small" type="text" onChange={onChangeTopicRelevance(indexTopic)} value={relevance} />
        </p>
        {removeTopicBtn}
      </div>
    )
  });

  const onChangeCatRelevance = () => {
    return ({ target: { value } }) => {
      saveCatRelevance(value, index);
    }
  }

  const onRemoveCategory=()=>{
    removeCategory(index);
  }

  const hasError = categoryHasError ? ' category-error' : '';

  let noTopicsError=false;
  if(categoryHasError && !topics.length) {
    noTopicsError=<h3 className="error-msg">Add at least one topic!</h3>
  }

  // Remove btn
  const removeBtn=<button onClick={onRemoveCategory} className="btn-remove-cat btn btn-default-cancel" type="button">Remove Category</button>

  return (
    <Card className="category-card font-color2">
      {removeBtn}
      <Modal isOpen={isOpen} onClose={onCloseMore} className="topic-seemore-modal">
        <div className="font-color2">
          <h3>{name} / {modalInfo.topic}</h3>
          <p dangerouslySetInnerHTML={modalInfo.descr}></p>
          <div className="modal-controls">
            <button onClick={onCloseMore} className="btn btn-default1" type="button">Ok</button>
          </div>
        </div>
      </Modal>
      <div className={"category-card-main-title"+hasError}>
        <h3>{order}. {name}</h3>
        <p className="category-card-relevance">
          Category relevance to your decision:
          <input className="textfield1 textfield1-small" type="text" onChange={onChangeCatRelevance()} value={relevance} />
        </p>
      </div>

      <div className="category-card-topics">
        <div className="topic-row topics-header">{topicsTHs}</div>
        {noTopicsError}
        {topicsRows}
      </div>

      <div className="category-card-footer">
        <button type="button" onClick={onOpenCloseAddTopic(true)} className="category-card-add-topic-btn">+ Add Topic</button>
      </div>

      <ModalTopic isOpen={isOpenAddTopic} onSave={onAddTopic} onClose={onOpenCloseAddTopic(false)} category={category} />

    </Card>
  )
}

const mapState2Props=({template})=>({
  errorIds:template.errorIds
})


const mapDispatch2Props = (dispatch) => {

  return {
    saveCatRelevance: (relevance, index) => dispatch(saveTemplateCatRelevance(relevance, index)),
    saveCatOrder: (order, index) => dispatch(saveTemplateCatOrder(order, index)),
    saveTopicRelevance: (relevance, index, index1) => dispatch(saveTemplateTopicRelevance(relevance, index, index1)),
    saveTopicOrder: (order, index, index1) => dispatch(saveTemplateTopicOrder(order, index, index1)),
    addTopic: (topicObj, index) => dispatch(addTemplateTopic(topicObj, index)),
    removeTopic: (index, index1) => dispatch(removeTemplateTopic(index, index1)),
    setEditing: () => dispatch(setTemplateEditing()),
    removeCategory: (index)=>dispatch(removeTemplateCategory(index))
  }
}

export default connect(mapState2Props, mapDispatch2Props)(CategoryCard);
